// import { useCallback, useContext, useState } from "react";
export default function _fetch(args: any, url: any) {
  const ENDPOINT = "https://api.manifiestos.censecar.com";
 //const ENDPOINT = "http://200.12.125.200"; 
 //const ENDPOINT = 'http://Localhost:8080';
  var myHeaders = new Headers();
  return new Promise((done, reject) => {
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('X-API-Key', '7dd1b2896693262605c41c691ce36288eff369b107743d887364c3831fb618c8');
    myHeaders.append('Cookie', 'connect.sid=s%3AP4gmmYSj4xzd7YUNsWK0Rc5k7lNB2lrl.P0hrya6f7ujlJAM18h9URKBlutt0cS6ZptsbOdq5ppg');
    var raw = JSON.stringify(args);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw
    };
    // DescripcionError:null
    fetch(`${ENDPOINT}` + url, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        done({
          Error_fectch: false,
          data: result
        });
      })
      .catch((error) => {
        reject({
          Error_fectch: true,
          data: error.message
        });
      });
  });
}
